import { useNavigate } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import CustomerSupportList from "../../features/manageCustomerSupport/customerSupportList";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomerSupport = () => {

  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  const [valueTabs2, setValueTabs2] = React.useState(0);
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs2(newValue);
  };

  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="main_title">
        <h1>Manage Customer Support</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Customer Support
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Pending" {...a11yProps(0)} />
              <Tab label="Resolved" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </Box>
          </div>
        </div>
        <CustomTabPanel value={valueTabs} index={0}>
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Customers" {...a11yProps(0)} />
              <Tab label="Service Providers" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={valueTabs1} index={0}>
            <CustomerSupportList status="pending" />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={1}>
            <CustomerSupportList status="pending" />
          </CustomTabPanel>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs2}
              onChange={handleChangeTabs2}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Customers" {...a11yProps(0)} />
              <Tab label="Service Providers" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={valueTabs2} index={0}>
            <CustomerSupportList status="resolved" />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs2} index={1}>
            <CustomerSupportList status="resolved" />
          </CustomTabPanel>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageCustomerSupport;
